"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var index_1 = require("../index");
exports.default = (function () {
    var _a = (0, react_1.useContext)(index_1.AppContext), attemptedCancel = _a.attemptedCancel, orderIsCancelled = _a.orderIsCancelled, resetToFirstStep = _a.resetToFirstStep, orderToCancel = _a.orderToCancel;
    // reset to the beginning if user has not gone through all the required steps first
    if (!orderToCancel || (!attemptedCancel && !orderIsCancelled)) {
        resetToFirstStep();
        return null;
    }
    return (react_1.default.createElement("div", { className: 'grid-container' },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('margin-vertical-15 padding-horizontal-3 bordered text-center padding-vertical-10', orderIsCancelled ? 'border-pale-gold' : 'border-error'), style: { backgroundColor: orderIsCancelled ? 'rgba(250, 215, 114, 0.1)' : 'rgba(255, 139, 142, .1)', borderRadius: '5px' } },
            react_1.default.createElement("i", { className: (0, classnames_1.default)('padding-1', orderIsCancelled ? 'ss-check border-olivine bordered rounded text-olivine' : 'ss-ban text-error') }),
            react_1.default.createElement("h6", { className: 'padding-vertical-3' }, orderIsCancelled ? 'ORDER CANCELLATION CONFIRMATION' : 'ORDER NOT CANCELLED'),
            orderIsCancelled && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'padding-vertical-5' }, "Your Order Has Been Cancelled!"),
                react_1.default.createElement("div", { className: 'padding-vertical-5' },
                    "Order #", orderToCancel === null || orderToCancel === void 0 ? void 0 :
                    orderToCancel.id,
                    " was successfully cancelled."),
                react_1.default.createElement("div", { className: 'padding-vertical-5' }, "Your refund will be posted back onto your original form of payment. Please allow 3-5 business days for processing."))),
            !orderIsCancelled && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'padding-vertical-5' },
                    "We\u2019re sorry but order #", orderToCancel === null || orderToCancel === void 0 ? void 0 :
                    orderToCancel.id,
                    " could not be cancelled."),
                react_1.default.createElement("div", { className: 'padding-vertical-5' }, "You will receive a shipping confirmation shortly and can set up a free return if needed."))))));
});
